import { Maximize, Minimize } from "lucide-react";

const Fullscreen = ({
  fullScreen,
  toggleFullScreen,
}: {
  fullScreen: boolean;
  toggleFullScreen: () => void;
}) => {
  return (
    <button onClick={toggleFullScreen} className="ea-full-screen-btn">
      {!fullScreen ? <Maximize /> : <Minimize />}
    </button>
  );
};

export default Fullscreen;
